(function() {
    'use strict';
    
a3_cabin_reports.factory('ServerCabinReportFactory', ServerCabinReportFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name ServerCabinReportFactory
    * @description 
    *   Manage Servers Cabin Reports
    * @ngInject
    */    
function ServerCabinReportFactory(GenericService) {

        /**
         * Initialiaze ServerCabinReport object 
         * @memberof ServerCabinReportFactory
         */
		function ServerCabinReport() {
			this.AuthorAimsId = null;
			this.AuthorName = null;
			this.Created = null;
			this.FlightAimsId = null;
			this.FlightId = null;
			this.LastUpdated = null;
			this.ReportGuid = null;
			this.ReportId = null;
			this.ReportedItems = null;
			this.Source = null;
			this.getDescription = getDescription;
			this.isNothingToReport = isNothingToReport;
		}

		var objCallback = ServerCabinReport;
			
		var service = {
			fromObjectList : fromObjectList,
			constSourceLocalOwn : 'localOwn',
			constSourceLocalOther : 'localOther',
			constSourceStoredOwn : 'storedOwn',
			constSourceStoredOther : 'storedOther'
		}   
	 
        /**
         * Get  ServerCabinReport Description
         * @memberof ServerCabinReportFactory
         * @returns {string} Description
         */  
		function getDescription() {
			if (this.Created == null && this.AuthorName == null && this.ReportedItems == null) return '-null-';
			else return (this.AuthorAimsId || '?') + ' ' + (this.AuthorName || '?') + ' @ ' + (this.Created || '?') + (this.ReportedItems || 0) == 0 ? ' :: Nothing to report' :      (this.ReportedItems || 0) + ' items logged';
		}

        /**
         * If there is something to report
         * @memberof ServerCabinReportFactory
         * @returns {bool} isNothingToReport
         */  
		function isNothingToReport() {
			return (this.ReportedItems || 0) == 0;
		}
			
		//Factory Settings
        /**
         * Extend given ServerCabinReport object List 
         * @memberof ServerCabinReportFactory
         * @param {object} obj The ServerCabinReport object that will be extended
         * @returns {array} ServerCabinReports
         */  
		function fromObjectList(objList) {
			return GenericService.fromObjectList(objList,objCallback);
		};

		return service;
	}

})();